import Cookies from 'universal-cookie';

function getEditorType() {
  // If there is cookie — it means that user specified the exact editor in settings
  // If there is no cookie — it means that user did not change the setting

  const v = new Cookies().get('editor-type');

  if (v === 'textarea') {
    return 'textarea';
  } else if (v === 'Ace') {
    return 'Ace';
  } else {
    // If there is no cookie, it means the user did not specify the editor.
    // In this case we use default — textarea on mobile and Ace on desktop
    // (on mobile Ace has a lot of problems, it does not work good on mobile)
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
    return isMobile ? 'textarea' : 'Ace';
  }
}

// For Node / CommonJS (tests, require)
if (typeof exports !== 'undefined') {
  exports.getEditorType = getEditorType;
}

// For ES module import
export { getEditorType };

export default getEditorType;
